import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "María García",
      location: "Madrid",
      rating: 5,
      text: "Ropa elegante y de muy buena calidad. Me encanta la selección de vestidos, perfectos para la oficina y para cualquier evento. Los precios son increíbles para la calidad que ofrecen.",
      avatar: "M"
    },
    {
      id: 2,
      name: "Carmen López",
      location: "Barcelona",
      rating: 5,
      text: "Descubrí Trucco aquí y ahora es una de mis marcas favoritas. La atención al detalle en cada prenda es impecable. Ya he repetido compra varias veces.",
      avatar: "C"
    },
    {
      id: 3,
      name: "Ana Martínez",
      location: "Valencia",
      rating: 5,
      text: "Perfecto para encontrar prendas bonitas a buen precio. Los abrigos de Naelle son una maravilla, elegantes y muy bien confeccionados. Totalmente recomendable.",
      avatar: "A"
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section data-testid="testimonials-section" className="section-padding bg-white">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-sans tracking-[0.2em] uppercase text-[#C8A96A] mb-4 block">
            Opiniones
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#111111]">
            Mujeres que ya confían en StyleOutlet
          </h2>
        </div>

        {/* Testimonials Slider */}
        <div className="relative max-w-4xl mx-auto">
          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            data-testid="testimonial-prev"
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-16 w-12 h-12 bg-white border border-[#111111]/10 rounded-full flex items-center justify-center hover:bg-[#C8A96A] hover:text-white hover:border-[#C8A96A] transition-all duration-300 cursor-pointer z-10"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          
          <button
            onClick={nextTestimonial}
            data-testid="testimonial-next"
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-16 w-12 h-12 bg-white border border-[#111111]/10 rounded-full flex items-center justify-center hover:bg-[#C8A96A] hover:text-white hover:border-[#C8A96A] transition-all duration-300 cursor-pointer z-10"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          {/* Testimonial Card */}
          <div className="testimonial-card rounded-lg p-8 md:p-12 text-center">
            {/* Quote Icon */}
            <div className="w-16 h-16 mx-auto mb-8 rounded-full bg-[#C8A96A]/10 flex items-center justify-center">
              <Quote className="w-8 h-8 text-[#C8A96A]" />
            </div>

            {/* Stars */}
            <div className="flex items-center justify-center gap-1 mb-6">
              {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#C8A96A] text-[#C8A96A]" />
              ))}
            </div>

            {/* Text */}
            <p 
              data-testid={`testimonial-text-${activeIndex}`}
              className="font-serif text-xl md:text-2xl text-[#111111] leading-relaxed mb-8 italic"
            >
              "{testimonials[activeIndex].text}"
            </p>

            {/* Author */}
            <div className="flex items-center justify-center gap-4">
              <div className="w-12 h-12 rounded-full bg-[#111111] text-white flex items-center justify-center font-serif text-lg font-bold">
                {testimonials[activeIndex].avatar}
              </div>
              <div className="text-left">
                <p className="font-sans font-bold text-[#111111]">
                  {testimonials[activeIndex].name}
                </p>
                <p className="font-sans text-sm text-[#8A8A8A]">
                  {testimonials[activeIndex].location}
                </p>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                data-testid={`testimonial-dot-${index}`}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === activeIndex ? 'bg-[#C8A96A] w-8' : 'bg-[#111111]/20'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
